import { Link } from "react-router-dom";
import Seo from "@/lib/Seo";
import { FadeUp } from "@/lib/motion";

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-ivory pt-[72px]">
      <Seo title="Page Not Found — Marble & Veil" description="The page you were looking for has moved or never existed." path="/404" />
      <FadeUp>
        <div className="px-6 text-center">
          <p className="mv-label">404</p>
          <h1 className="mt-4 font-display text-5xl text-ink sm:text-6xl">This page stepped out.</h1>
          <p className="mx-auto mt-5 max-w-md text-smoke">
            The detail you were looking for is not here — but the collection is, and it would love the
            company.
          </p>
          <div className="mt-9 flex flex-wrap justify-center gap-4">
            <Link to="/" data-testid="notfound-home-link" className="rounded-none bg-olive px-9 py-4 text-[12px] uppercase tracking-[0.18em] text-ivory transition-transform duration-300 hover:-translate-y-0.5">
              Back to the Beginning
            </Link>
            <Link to="/shop" className="border border-ink/25 px-9 py-4 text-[12px] uppercase tracking-[0.18em] text-ink transition-colors hover:border-olive hover:text-olive">
              Explore the Collection
            </Link>
          </div>
        </div>
      </FadeUp>
    </div>
  );
}
